/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.


import moment from 'moment'
import PropTypes from 'prop-types'
import ReactRedirect from 'react-redirect'
import { captureExceptions } from 'utils/SentryHelpers'
import Dashboard from 'components/ConversationStats/InboxMetrics'
const CONVERSATION_STATS_PATH = '/conversation-stats'

const RootDashboardRedirect = React.createClass({

  contextTypes: {
    router: PropTypes.object.isRequired
  },

  // Default to a week time range
  getDefaultDates() {
    return {
      startDate: moment().subtract(6, 'days').startOf('day').valueOf(),
      endDate: moment().endOf('day').valueOf()
    }
  },

  componentWillMount() {
    const { query } = this.props.location
    if (!query.inboxId || !query.metric || !query.startDate || !query.endDate) {
      return this.redirectToDefaultDashboard()
    }
  },

  render() {
    return <Dashboard query={this.props.location.query} />
  },

  redirectToDefaultDashboard() {
    const defaultDates = this.getDefaultDates()

    const query = {
      metric: 'NEW_CONVERSATIONS',
      inboxId: __guard__(_.head(_.values(this.props.inboxesById)), x => x.id),
      startDate: defaultDates.startDate,
      endDate: defaultDates.endDate
    }
    return this.context.router.replace({ pathname: CONVERSATION_STATS_PATH, query })
  }
})

export default Marty.createContainer(RootDashboardRedirect, {

  listenTo: ['stores.InboxStore'],

  fetch: {
    inboxesById() {
      return this.app.stores.InboxStore.getOrFetchInboxList()
    }
  },

  failed(errors) {
    captureExceptions(errors)
    return <div />
  }
})

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}



// WEBPACK FOOTER //
// ./src/scripts/components/ConversationStats/RootDashboardRedirect.js